import { render, staticRenderFns } from "./menuPc.vue?vue&type=template&id=e902b602&scoped=true"
import script from "./menuPc.vue?vue&type=script&lang=js"
export * from "./menuPc.vue?vue&type=script&lang=js"
import style0 from "./menuPc.vue?vue&type=style&index=0&id=e902b602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e902b602",
  null
  
)

export default component.exports